import React from "react";
import "./style.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {
  FaCode,
  FaGlobe,
  FaChartLine,
  FaSyncAlt,
  // FaTasks, // temporarily unused
  FaLightbulb,
  FaOilCan,
  // FaShoppingCart, // temporarily unused
  FaShip,
  FaTruck,
  FaGlobeAmericas,
} from "react-icons/fa";

const digitalSolutions = [
  {
    icon: <FaCode />,
    title: "Custom Software Development",
    variant: "purple",
    description:
      "Build tailored software solutions engineered around your exact business needs and workflows.",
  },
  {
    icon: <FaGlobe />,
    title: "Web Application Development",
    variant: "pink",
    description:
      "Design and develop fast, scalable web applications that deliver seamless user experiences.",
  },
  {
    image: "/img/MobileGameDevelopment.svg",
    title: "Mobile Game Development",
    variant: "blue",
    description:
      "Craft exceptional mobile games with stunning graphics, engaging gameplay, and seamless performance.",
  },
  {
    image: "/img/VirtualReality.svg",
    title: "Virtual Reality (VR) Development",
    variant: "teal",
    description:
      "Create unforgettable virtual worlds that transport players into truly immersive environments.",
  },
  {
    image: "/img/AugmentedReality.svg",
    title: "Augmented Reality (AR) Development",
    variant: "yellow",
    description:
      "Enhance the real world with interactive and immersive AR experiences for gaming, education, and more.",
  },
  {
    image: "/img/Web3GameServices.svg",
    title: "Web3 In-Game Services",
    variant: "cream",
    description:
      "Integrate blockchain, NFTs, and decentralized finance to power secure, next-generation gaming experiences.",
  },
];

const businessSolutions = [
  {
    icon: <FaChartLine />,
    title: "Business Development",
    variant: "pink",
    description:
      "Identify new opportunities and build strategies that drive sustainable business growth.",
  },
  {
    icon: <FaSyncAlt />,
    title: "Digital Transformation",
    variant: "teal",
    description:
      "Modernize operations and adopt the right technology to work smarter and stay competitive.",
  },
  // {
  //   icon: <FaTasks />,
  //   title: "Project Management",
  //   variant: "purple",
  //   description:
  //     "Keep initiatives on track with structured planning, coordination, and delivery oversight.",
  // },
  {
    icon: <FaLightbulb />,
    title: "Technical Advisory",
    variant: "yellow",
    description:
      "Get expert guidance on technology decisions that align with your business goals.",
  },
];

const specializedProducts = [
  {
    icon: <FaOilCan />,
    title: "Global Marine Lubricant Supply",
    variant: "cream",
    description:
      "Source high-quality Marine Lubricant Supply through our trusted network of international partners.",
    featured: true,
    badge: "Our Specialty",
  },
];

const supplyServices = [
  // {
  //   icon: <FaShoppingCart />,
  //   title: "Procurement Services",
  //   variant: "blue",
  //   description:
  //     "Reliable procurement solutions that connect you with trusted suppliers worldwide.",
  // },
  {
    icon: <FaShip />,
    title: "Import & Export",
    variant: "pink",
    description:
      "Navigate cross-border trade with dependable import and export coordination.",
  },
  {
    icon: <FaTruck />,
    title: "Logistics Coordination",
    variant: "yellow",
    description:
      "End-to-end logistics management that keeps your supply chain moving smoothly.",
  },
  {
    icon: <FaGlobeAmericas />,
    title: "International Trading",
    variant: "teal",
    description:
      "Trade across regional and international markets backed by a trusted global network.",
  },
];

function ServiceCard({
  icon,
  image,
  title,
  variant,
  description,
  featured,
  badge,
}) {
  return (
    <Col lg={featured ? 12 : 4} md={featured ? 12 : 6} className="mb-4">
      <div className={`OurServices-content${featured ? " featured" : ""}`}>
        {badge && <span className="OurServices-badge">{badge}</span>}
        {image ? (
          <img src={image} alt={title} className="OurServicesImage" />
        ) : (
          <div className={`OurServicesIcon variant-${variant}`}>{icon}</div>
        )}
        <div>
          <h5 id="id_h5Services">{title}</h5>
          {description && <p>{description}</p>}
        </div>
      </div>
    </Col>
  );
}

function Services(props) {
  return (
    <>
      <img
        src="/img/Services.svg"
        alt="Services"
        className="ServicesImage pb-5"
        id="services"
      />
      <Row className="justify-content-center">
        <Col md={10}>
          <Row className="align-items-center minHeight-85">
            <Col lg={12} className="Services-content">
              <h1 id="id_h1Services">Our Services</h1>
            </Col>

            <Col lg={12} className="ServicesPillar" id="digital-solutions">
              <h2>Digital Solutions</h2>
              <p>
                We design and develop modern digital products that transform
                ideas into scalable solutions.
              </p>
              <Row className="justify-content-center">
                {digitalSolutions.map((service) => (
                  <ServiceCard key={service.title} {...service} />
                ))}
              </Row>
            </Col>

            <Col lg={12} className="ServicesPillar" id="business-solutions">
              <h2>Business Solutions</h2>
              <p>
                We help organizations improve performance, embrace innovation,
                and achieve sustainable growth through practical business and
                consulting services.
              </p>
              <Row className="justify-content-center">
                {businessSolutions.map((service) => (
                  <ServiceCard key={service.title} {...service} />
                ))}
              </Row>
            </Col>

            <Col
              lg={12}
              className="ServicesPillar"
              id="supply-trading-solutions"
            >
              <h2>Supply &amp; Trading Solutions</h2>
              <p>
                We connect businesses with trusted suppliers and reliable
                sourcing solutions across regional and international markets.
              </p>
              {/* <h6 className="ServicesSubgroup">Specialized Products</h6> */}
              <Row className="justify-content-center">
                {specializedProducts.map((service) => (
                  <ServiceCard key={service.title} {...service} />
                ))}
              </Row>
              {/* <h6 className="ServicesSubgroup">Supply Services</h6> */}
              <Row className="justify-content-center">
                {supplyServices.map((service) => (
                  <ServiceCard key={service.title} {...service} />
                ))}
              </Row>
              {/* <p className="ServicesPillar-note">
                Our primary focus is supplying high-quality Personal Wellness
                Products through trusted international partners. We also support
                clients with sourcing, logistics, and international trading for
                a wide range of products tailored to their business needs.
              </p> */}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default Services;
